import AddClientAllocation from './AddClientAllocation';

export default AddClientAllocation;
